import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/college-shipping-storage-moving-services.jpg'),
    alt: 'college shipping storage moving services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college shipping storage moving services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Efficient <span>College</span><span>Shipping, Storage, and Moving Services</span>',
  description:
    "Simplify your college move with ShipAndStorage’s fast and reliable College Shipping, Storage, and Moving Services. We offer flexible, affordable solutions tailored to meet students' needs nationwide.",
  points: [
    'Up to 6 Months Free Storage',
    'Free Insurance up to $250',
    '1 Small Box to 100 Large Box Storage',
    'Storage Services with Freedom'
  ],
  image: {
    url: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/hero-image.svg',
    alt: 'college shipping storage moving services page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign up' }
}

export const helperGuideSection = {
  title: 'Fast College Storage and Moving Services',
  description:
    'Our fast and efficient College Shipping Storage Moving Services ensure your items are taken care of every step of the way. Here’s how it works:',

  ctaButton: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },
  cards: [
    {
      id: 1,
      title: 'Book Online',
      description: 'Schedule your College Shipping, Storage, and Moving Services quickly through our online platform.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/book-online-service.svg',
        alt: 'Book Online service'
      }
    },
    {
      id: 2,
      title: 'We Pick Up',
      description: 'Our team will pick up your items directly from your dorm, apartment, or campus location.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/we-pick-up.svg',
        alt: 'We Pick Up service'
      }
    },
    {
      id: 3,
      title: 'Safe Storage & Delivery',
      description:
        'Your belongings are securely stored, and we offer flexible delivery options to send them where and when you need them.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/safe-storage-&-delivery-service.svg',
        alt: 'Safe Storage & Delivery service'
      }
    },

    {
      id: 4,
      title: 'Affordable College Storage and Shipping',
      description:
        'At ShipAndStorage, we provide students with affordable College Shipping Storage Moving Services designed to fit student budgets. Whether you need short-term storage or long-distance shipping, our flexible solutions keep your items safe and secure without added stress or high costs.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/book-online-service.svg',
        alt: 'Affordable College Storage and Shipping service'
      }
    }
  ]
}

export const WhySelfStorageSectionContent = {
  title: 'Why Self Storage Service Is Necessary?',
  cards: [
    {
      id: 1,
      title: 'Declutter Your Surroundings',
      description:
        'Create more space in your home or office by storing items you seldom need. Our storage solutions help you cultivate a clean and organized atmosphere.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/declutter-your-surroundings.svg',
        alt: 'Declutter Your Surroundings'
      }
    },
    {
      id: 2,
      title: 'Ease Your Relocation Journey',
      description:
        'Make moving easier by using temporary storage for your possessions. Safely store furniture, appliances, and other essentials until you’re ready to relocate them.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/ease-your-relocation-journey.svg',
        alt: 'Ease Your Relocation Journey'
      }
    },
    {
      id: 3,
      title: 'Protect Your Seasonal Belongings',
      description:
        'Store your seasonal items, sports gear, or valuable personal possessions securely in our monitored storage facilities, with flexible terms for short or long-term use.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/protect-your-seasonal-belongings.svg',
        alt: 'Protect Your Seasonal Belongings'
      }
    }
  ]
}

export const gridSectionContent = {
  title: 'Who Should Choose ShipAndStorage Service for College Student Storage?',
  cards: [
    {
      id: 1,
      title: 'Summer Storage for Dorm Essentials',
      description: 'Safely store your dorm items over summer break without the hassle of bringing them home.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/summer-storage-for-dorm-essentials.svg',
        alt: 'Summer Storage for Dorm Essentials'
      }
    },
    {
      id: 2,
      title: 'Convenient for Out-of-State Students',
      description: 'Avoid constant back-and-forth shipping and keep belongings close to campus.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/convenient-for-out-of-state-students.svg',
        alt: 'Convenient for Out-of-State Students'
      }
    },
    {
      id: 3,
      title: 'Free Up Dorm Space',
      description: 'Store seasonal clothes and extras to keep your living space clutter-free.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/free-up-dorm-space.svg',
        alt: 'Free Up Dorm Space'
      }
    },

    {
      id: 4,
      title: 'Ideal for Gap Semesters',
      description: 'Store your belongings securely while you’re away, ready when you return.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/ideal-for-gap-semesters.png',
        alt: 'Ideal for Gap Semesters'
      }
    },
    {
      id: 5,
      title: 'Graduates on the Move',
      description: 'Keep items stored as you prepare for the next chapter, whether relocating or job hunting.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/graduates-on-the-move.svg',
        alt: 'Graduates on the Move'
      }
    },
    {
      id: 6,
      title: 'Perfect for Student Organizations',
      description: 'Store equipment and supplies off-season for sports teams, clubs, or events.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/perfect-for-student-organizations.svg',
        alt: 'Perfect for Student Organizations'
      }
    }
  ]
}

export const evenOddList = {
  title: 'Our Different Storage Services',
  description: '',

  articles: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Scalable, cost-effective storage for businesses that need extra space for inventory, documents, or equipment.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: {
        text: 'Explore Business Storage',
        href: PUBLIC_MAIN_ROUTES.BUSINESS_STORAGE.href
      }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Ideal for students or anyone moving long-distance, offering seamless pickup, storage, and delivery of your belongings.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/moving-storage-solution.svg',
        alt: 'Moving Storage Solution'
      },
      link: {
        text: 'Explore Moving Storage',
        href: PUBLIC_MAIN_ROUTES.MOVING_STORAGE_SOLUTIONS.href
      }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Reliable services for shipping your luggage and boxes, perfect for students traveling back home or starting new adventures.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/luggage-and-box-shipping-services-solution.svg',
        alt: 'Luggage and Box Shipping Services'
      },
      link: {
        text: 'Explore Luggage & Box Shipping',
        href: PUBLIC_MAIN_ROUTES.LUGGAGE_BOX_SHIPPING_SERVICES.href
      }
    },
    {
      id: 4,
      title: 'Residential Storage Solution',
      description:
        'Flexible, convenient storage options to help families during moves, renovations, or seasonal transitions.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/residential-storage-solution.svg',
        alt: 'Residential Storage Solution'
      },
      link: {
        text: 'Explore Residential Storage',
        href: PUBLIC_MAIN_ROUTES.RESIDENTIAL_STORAGE.href
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose ShipAndStorage for College Shipping, Storage, and Moving Services?',
  description: '',

  cards: [
    {
      id: 1,
      title: 'Comprehensive Solutions',
      description:
        'We provide a full suite of services for College Shipping, Storage, and Moving, making your transition smooth and easy.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/comprehensive-solutions.svg',
        alt: 'Comprehensive Solutions'
      }
    },
    {
      id: 2,
      title: 'Student-Friendly Pricing',
      description:
        'ShipAndStorage understands student budgets and offers affordable, flexible packages without compromising on service quality.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/student-friendly-pricing.svg',
        alt: 'Student-Friendly Pricing'
      }
    },
    {
      id: 3,
      title: 'Nationwide Service',
      description:
        'We make the process seamless from start to finish, offering flexible storage options, easy booking, and fast delivery.',
      image: {
        src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/nationwide-service.svg',
        alt: 'Nationwide Service'
      }
    }
  ]
}

export const infoBannerSectionContent = {
  id: 1,
  title: 'College Shipping Storage Moving Services Available Fast',
  description:
    'College shipping, storage, and moving services in one. Fast and affordable solutions to store, move, and ship your belongings easily.',
  image: {
    src: '/images/v2/pages/landing-pages/college-shipping-storage-moving-services/college-shipping-storage-moving-services-available-fast.svg',
    alt: 'College Shipping Storage Moving Services Available Fast'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'At ShipAndStorage, we provide world-class shipping and storage solutions by partnering with leading global carriers such as FedEx, DHL, and UPS. These partnerships ensure your shipments are handled with the highest levels of reliability, efficiency, and care. ',
  questions: [
    {
      id: 1,
      question: 'FedEx',
      answer:
        'Founded by Frederick W. Smith in 1971, FedEx began with just 186 packages and has grown into a global leader in shipping services. Today, FedEx operates a vast fleet of 696 aircraft and 215,000 vehicles, processing 16 million shipments daily to over 220 countries and territories. With more than 550,000 employees and over 5,000 centers worldwide, FedEx guarantees reliable and timely deliveries.|||Disclaimer – FedEx Luggage Shipping Services|||This page was last updated in September 2024 for reference purposes only. FedEx makes no warranties, express or implied, regarding the accuracy or completeness of the information provided.'
    },

    {
      id: 2,
      question: 'DHL',
      answer:
        'DHL Express, a prominent division of Deutsche Post DHL Group, is renowned for its international courier, parcel, and express mail services. As a global leader in logistics, DHL handles over 1.8 billion parcels each year. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became fully owned by Deutsche Post in 2002 and now operates in over 220 countries, ensuring its vital role in the global supply chain.|||Disclaimer:||| This page was last updated in September 2024 and is provided for reference purposes only. DHL makes no warranties regarding the accuracy of the information provided.'
    },
    {
      id: 3,
      question: 'UPS',
      answer:
        'UPS, originally founded as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, re-branded as United Parcel Service (UPS) in 1919. Today, UPS is one of the largest global shipping companies, delivering 25 million packages daily. With over 500,000 employees worldwide, UPS serves more than 220 countries and territories, offering unmatched global reach.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. UPS makes no warranties regarding the accuracy of the information provided. For more details, visit'
    }
  ]
}
